const state = {
    loading: false,
    pendingRequests: 0
};

const actions = {
    loading({ commit }, flag) {
        commit('loading', flag);
    },
    increasePendingRequests({ commit }) {
        commit('pendingRequests', 1);
    },
    decreasePendingRequests({ commit }) {
        commit('pendingRequests', -1);
    }
};
const mutations = {
    loading(state, flag) {
        state.loading = flag;
    },
    pendingRequests(state, amount) {
        state.pendingRequests += amount;
        if (state.pendingRequests < 0) {
            state.pendingRequests = 0;
        }
    }
};

const getters = {
    loading: (state) => state.loading,
    pendingRequests: (state) => state.pendingRequests
};

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
};